import { format } from "date-fns";
import { formatBRL } from "@/lib/currency.ts";
import { dateOnlyToDate } from "@/lib/format.ts";

const percentFormatter = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	maximumFractionDigits: 0,
});

export function formatProgressPercent(percent: number): string {
	return percentFormatter.format(percent / 100);
}

export function formatMeasuredOn(value: string | undefined): string | null {
	const date = dateOnlyToDate(value);
	return date ? format(date, "dd/MM/yy") : null;
}

const decimalPercentFormatter = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	maximumFractionDigits: 2,
});

const signedPercentFormatter = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	maximumFractionDigits: 2,
	signDisplay: "exceptZero",
});

export function formatDecimalPercent(percent: number): string {
	return decimalPercentFormatter.format(percent / 100);
}

export function formatSignedPercent(percent: number): string {
	return signedPercentFormatter.format(percent / 100);
}

export function formatSignedBRL(cents: number): string {
	if (cents > 0) return `+${formatBRL(cents)}`;
	return formatBRL(cents);
}
